'use client';

import { Box, Stack, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';

import Link from '@/components/Link';
import colors from '@/styles/themes/colors';

import styles from './LocationBadge.module.scss';

interface LocationBadgeProps {
  className?: string;
  hasLink?: boolean;
}

const LocationBadge = ({ className, hasLink }: LocationBadgeProps) => {
  const t = useTranslations('common');

  return (
    <Stack className={className} direction="row" alignItems={hasLink ? 'flex-start' : 'center'} spacing={1.5}>
      <Stack alignItems="center" justifyContent="center" className={styles.mapPinOuter}>
        <Box className={styles.mapPinInner} />
      </Stack>
      <Stack>
        <Typography variant="subtitle1" component="p" color={colors.white} whiteSpace="nowrap">
          {t('map.locationTitle')}
        </Typography>
        <Typography variant="body1">{t('map.locationAddress')}</Typography>
        {hasLink && <Link href="/office" text={t('map.link')} className={styles.link} />}
      </Stack>
    </Stack>
  );
};

export default LocationBadge;
